import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  TenantListRequest,
  TenantListResponse,
  Tenant,
  TenantCreateRequest,
  TenantUpdateRequest,
  TenantShortListResponse,
} from "./types";

/**
 * List
 */
export const tenantListService = (params: TenantListRequest) =>
  RestAPIClient.call<TenantListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const tenantListShortService = (params: TenantListRequest) =>
  RestAPIClient.call<TenantShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const tenantDetailService = (id: number) =>
  RestAPIClient.call<Tenant>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const tenantCreateService = (data: TenantCreateRequest) =>
  RestAPIClient.call<Tenant>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const tenantUpdateService = (data: TenantUpdateRequest) =>
  RestAPIClient.call<Tenant>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
